export const packages = [
  { 
    id: 1, 
    destination: "Santorini, Greece", 
    days: 7, 
    price: 2499, 
    image: "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&q=80",
    rating: 4.9,
    reviews: 124,
    tags: ["Romance", "Beach", "History"]
  },
  { 
    id: 2, 
    destination: "Kyoto, Japan", 
    days: 10, 
    price: 3299, 
    image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&q=80",
    rating: 4.8,
    reviews: 89,
    tags: ["Culture", "Nature", "Food"]
  },
  { 
    id: 3, 
    destination: "Machu Picchu, Peru", 
    days: 8, 
    price: 1899, 
    image: "https://images.unsplash.com/photo-1587595431973-160d0d94add1?auto=format&fit=crop&q=80",
    rating: 4.9,
    reviews: 210,
    tags: ["Adventure", "History", "Hiking"]
  },
  { 
    id: 4, 
    destination: "Maldives", 
    days: 6, 
    price: 4500, 
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&q=80",
    rating: 5.0,
    reviews: 156,
    tags: ["Luxury", "Beach", "Relaxation"]
  }
];

export const reviews = [
    { id: 1, user: "Sarah M.", text: "Best trip of my life! The itinerary was perfect.", rating: 5, image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80" },
    { id: 2, user: "James Bond", text: "Luxury all the way. Highly recommended.", rating: 5, image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80" },
    { id: 3, user: "Emily Clark", text: "Amazing views and great guides.", rating: 4, image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80" },
];
